import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { awards as awardsApi } from 'redux/modules/api'

function decorator() {
  return ComposedComponent => {
    @connect(({ api }) => ({
      awards: api.awards
    }), { ...awardsApi })

    class Awards extends Component {
      static propTypes = {
        awards: PropTypes.object.isRequired,
        getPublicLevels: PropTypes.func.isRequired,
        getAllowedLevels: PropTypes.func.isRequired,
      }

      componentDidMount() {
        const { awards, getPublicLevels } = this.props

        !(awards.loading || awards.loaded) && getPublicLevels()
      }

      handleGetAllowedLevels = code => this.props.getAllowedLevels(code)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onGetAllowedLevels={this.handleGetAllowedLevels}
          />
        )
      }
    }
    return Awards
  }
}

export default decorator
